export default {
  'menu.welcome': 'Selamat Datang',
  'menu.home': 'Halaman Awal',
  'menu.login': 'Masuk',

  // Modul Manajemen Sistem
  'menu.system': 'Manajemen Sistem',
  'menu.system.welcome': 'Beranda Sistem',
  'menu.system.dict': 'Manajemen Kamus',
  'menu.system.menu': 'Manajemen Menu',
  'menu.system.role': 'Manajemen Peran',
  'menu.system.noAuth': 'Antarmuka Tanpa Autentikasi',

  // Modul Manajemen Acara
  'menu.event': 'Manajemen Acara',
  'menu.event.eventRecord': 'Catatan Acara',
  'menu.event.eventOrder': 'Pesanan Acara',
  'menu.event.eventOrderNode': 'Node Pesanan',
  'menu.event.eventReceiver': 'Penerima Acara',
  'menu.event.resourceFile': 'File Sumber Daya',

  // Modul Manajemen Organisasi
  'menu.organization': 'Manajemen Organisasi',
  'menu.organization.orgDept': 'Manajemen Departemen',
  'menu.organization.orgPost': 'Manajemen Jabatan',
  'menu.organization.orgTree': 'Struktur Organisasi',
  'menu.organization.employee': 'Manajemen Karyawan',

  // Modul Manajemen Perangkat
  'menu.device': 'Manajemen Perangkat',
  'menu.device.deviceModel': 'Model Perangkat',
  'menu.device.deviceSupplier': 'Pemasok Perangkat',
  'menu.device.deviceGateway': 'Gateway Perangkat',
  'menu.device.deviceTerminal': 'Terminal Perangkat',
  'menu.device.deviceManagement': 'Manajemen Perangkat',

  // Modul Manajemen Paket
  'menu.package': 'Manajemen Paket',
  'menu.package.myPackage': 'Paket Saya',
  'menu.package.subPackage': 'Paket Anak',

  // Manajemen Pengguna
  'menu.user': 'Manajemen Pengguna',

  // Modul Fusi Video
  'menu.video': 'Fusi Video',
  'menu.video.preview': 'Pratinjau Waktu Nyata',
  'menu.video.playback': 'Pemutaran Riwayat',
  'menu.video.recording': 'Perekaman Manual',
};
